import { MeetingType } from "@teams/types";
import { useMemo } from "react";

import { useTeamsContext } from "../../../../../_shared/state/TeamsContextProvider";

export function useTrackingProperties(data: { isPersonal: boolean }) {
  const { isPersonal } = data;
  const { teamsContext } = useTeamsContext();

  const [inActiveMeeting, groupType, hostClientType, meetingType] = useMemo(() => {
    const isMeetingContext = !!teamsContext.meeting?.id;
    const isSidePanel = teamsContext.page.frameContext === "sidePanel";
    const isMeetingBubble = teamsContext.page.isMultiWindow;

    const inActiveMeeting = isMeetingContext && (isSidePanel || isMeetingBubble);

    let groupType: string;
    let meetingType: MeetingType | undefined;
    if (isPersonal) {
      groupType = "personal";
    } else if (teamsContext.channel?.id && !teamsContext.meeting?.id) {
      groupType = "team";
    } else if (teamsContext.meeting?.id) {
      groupType = "meeting";
    } else if (teamsContext.chat?.id) {
      groupType = "groupChat";
    } else {
      groupType = "unknown";
    }

    if (groupType === "meeting") {
      if (teamsContext.channel?.id || teamsContext.team?.internalId) {
        meetingType = "channel";
      } else if (teamsContext.chat?.id && !teamsContext.chat?.id.includes("meeting_")) {
        meetingType = "groupChat";
      } else if (teamsContext.chat?.id && teamsContext.chat?.id.includes("meeting_")) {
        meetingType = "calendar";
      }
    }
    const hostClientType = teamsContext.app.host.clientType;

    return [inActiveMeeting, groupType, hostClientType, meetingType];
  }, [teamsContext, isPersonal]);

  return { inActiveMeeting, groupType, hostClientType, meetingType };
}
